import {useNavigate} from "react-router";
import {useEffect} from "react";
import MemoryContext from "../../util/MemoryContext";
import {SessionContext} from "../../util/SessionContext";
import EventBus from "../../util/EventBus";

export default function Logout() {

    const navigate = useNavigate();

    useEffect(() => {

        sessionStorage.clear();
        let sessionContext = new SessionContext();
        sessionContext.setShowLoginDialog(true);

        MemoryContext.components = {}

        // @ts-ignore
        EventBus.session.emit("update");

        navigate("/", {replace: true});

    }, [navigate]);

    return null;
}
